import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
type Purchase = {
  name: string;
  city: string;
  minutes: number;
};
const purchases: Purchase[] = [{
  name: 'Daniela H.',
  city: 'Córdoba',
  minutes: 7
}, {
  name: 'Martín G.',
  city: 'Buenos Aires',
  minutes: 12
}, {
  name: 'Lucía F.',
  city: 'Rosario',
  minutes: 3
}, {
  name: 'Nicolás P.',
  city: 'Mendoza',
  minutes: 20
}, {
  name: 'Valentina S.',
  city: 'La Plata',
  minutes: 5
}, {
  name: 'Federico R.',
  city: 'Mar del Plata',
  minutes: 15
}, {
  name: 'Camila T.',
  city: 'Salta',
  minutes: 9
}, {
  name: 'Ignacio M.',
  city: 'Tucumán',
  minutes: 18
}, {
  name: 'Sofía A.',
  city: 'Neuquén',
  minutes: 4
}, {
  name: 'Tomás B.',
  city: 'San Juan',
  minutes: 11
}];
const DISPLAY_DURATION = 8500;
const ROTATION_INTERVAL = 20000;
const DISMISS_DELAY = 30000;
export function VerifiedPurchasePopup() {
  const [purchaseIndex, setPurchaseIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  useEffect(() => {
    const rotation = window.setInterval(() => {
      setIsVisible(false);
      window.setTimeout(() => {
        setPurchaseIndex(current => getNextIndex(current));
        setIsVisible(true);
      }, 350);
    }, ROTATION_INTERVAL);
    return () => window.clearInterval(rotation);
  }, []);
  useEffect(() => {
    if (isVisible) {
      const hide = window.setTimeout(() => setIsVisible(false), DISPLAY_DURATION);
      return () => window.clearTimeout(hide);
    }
    return undefined;
  }, [isVisible, purchaseIndex]);
  function handleDismiss() {
    setIsVisible(false);
    window.setTimeout(() => {
      setPurchaseIndex(current => getNextIndex(current));
      setIsVisible(true);
    }, DISMISS_DELAY);
  }
  const purchase = purchases[purchaseIndex];
  return <AnimatePresence data-id="element-273" data-mp="18juro5mfr5qb">
      {isVisible && <motion.aside key={purchase.name} role="status" aria-live="polite" initial={{
      opacity: 0,
      x: -20,
      y: 12
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -20,
      y: 12
    }} transition={{
      duration: 0.28,
      ease: [0.21, 0.47, 0.32, 0.98]
    }} className="fixed bottom-4 left-4 z-50 w-[calc(100vw-2rem)] max-w-sm rounded-xl border border-brand/40 bg-black p-4 pr-10 shadow-2xl shadow-black/50 sm:bottom-6 sm:left-6" data-id="element-274" data-mp="13nw9izrpajyc">
          <button type="button" onClick={handleDismiss} aria-label="Cerrar notificación de compra" className="absolute right-2 top-2 flex h-8 w-8 items-center justify-center rounded-md text-gray-500 transition-colors hover:bg-white/5 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-275" data-mp="1adfnkhaeu77o">
            <XIcon className="h-4 w-4" data-id="element-276" data-mp="1odqflnnghruf" />
          </button>

          <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-wide text-brand" data-id="element-277" data-mp="2usr1t1moivnt">
            <span className="relative flex h-2 w-2" data-id="element-278" data-mp="2zqstuc2325bf">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand opacity-60" data-id="element-279" data-mp="2ztf2kf0pmqv8" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-brand" data-id="element-280" data-mp="o5teph3ly7jd" />
            </span>
            Compra verificada
          </p>
          <p className="mt-3 text-sm leading-relaxed text-gray-200" data-id="element-281" data-mp="ed474xb6hdtb">
            <span className="font-semibold text-white" data-id="element-282" data-mp="9fccvwn29fly">{purchase.name}</span> de{' '}
            <span className="font-semibold text-white" data-id="element-283" data-mp="5dhep10ffice">{purchase.city}</span> compró
            Capital Consciente <span aria-hidden="true" data-id="element-284" data-mp="eeafis9tg5h">🏆</span>
          </p>
          <p className="mt-2 text-xs text-gray-500" data-id="element-285" data-mp="ctfhs21nv73">hace {purchase.minutes} minutos</p>
        </motion.aside>}
    </AnimatePresence>;
}
function getNextIndex(currentIndex: number) {
  let nextIndex = Math.floor(Math.random() * purchases.length);
  if (purchases.length > 1 && nextIndex === currentIndex) {
    nextIndex = (nextIndex + 1) % purchases.length;
  }
  return nextIndex;
}